import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { Accordion, Card, FormGroup, Button } from 'react-bootstrap';
import { MultiSelect } from 'react-multi-select-component';
import { checkArray, createOptions, customStyles, setImage } from '../../helper';
import { getPCTypesDetails, getPlacementDetails, getSupplierStatusDetails } from '../../../Pages/SystemMasters/Store/SystemMasters.action';
import { getBOMOptions } from '../../../Pages/Library/BomLibrary/store/BomLibrary.action';
import { AlignmentConfig } from '../../../Pages/Library/DPP/Library/ControlConfig/AlignmentConfig';
import { BoldConfig } from '../../../Pages/Library/DPP/Library/ControlConfig/BoldConfig';
import { ColorConfig } from '../../../Pages/Library/DPP/Library/ControlConfig/ColorConfig';
import noImage from '../../../assets/images/no-image.png';
import { fetchUserDocumentsList } from '../../../Pages/UserSetting/store/User.action';
import { fetchDPPBom } from '../../../Pages/DevlopmentOrder/DPPModule/store/DPPModule.action';
import borderThickSvg from "../../../assets/images/Stroke_'Thickness.svg";

const tierOptions = [
  { name: 'Tier 1', value: 'Tier1', type: 4 },
  { name: 'Tier 2', value: 'Tier2', type: 4 },
  { name: 'Tier 3', value: 'Tier3', type: 4 },
  { name: 'Tier 4', value: 'Tier4', type: 4 },
];

const verticalStyleOptions = [
  { label: 'Solid', value: 'solid' },
  { label: 'Dashed', value: 'dashed ' },
];

const borderStyleOptions = [
  { label: '1px', value: '1px' },
  { label: '3px', value: '3px' },
  { label: '5px', value: '5px' },
];

const customStylesNew = {
  ...customStyles,
  control: () => ({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    // height: "100%",
    height: '30px',
    borderBottom: '1px solid #6a6a6a',
  }),
};

const customStylesBorderThickness = {
  ...customStyles,
  control: () => ({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    // height: "100%",
    height: '22px',
    border: '1px solid #6a6a6a',
  }),
};

export function ProductJourneySetting({ obj, updateSetting, onChange, handleOtherConfig, handleImageUpload, fromProduct, devProductData, libraryBasicData }) {
  const { t } = useTranslation('common');
  const [state, setState] = useState({
    isOpen: false,
    bomType: null,
    allBoms: [],
    isAllBom: obj?.isAllBom || false,
    placement: obj?.placement || [],
  });
  const reducer = useSelector((reducerstate) => reducerstate);
  const { SystemMastersDetails, UserDetails, BomLibraryDetails, Users, DPPProductReducer } = reducer;
  const { bomOptionsList } = BomLibraryDetails;
  const { productBOM } = DPPProductReducer;
  const { pcTypeList, supplierStatusList, placement_master } = SystemMastersDetails;
  const { userInfo } = UserDetails;
  const { documentsList } = Users;
  const [allBOMOptions, setAllBOMOptions] = useState([]);
  const [activeAccordion, setActiveAccordion] = useState(null);
  const dispatch = useDispatch();

  const TierOptionsList = useMemo(() => {
    if (checkArray(tierOptions)) return createOptions(tierOptions, 'name', 'value');
    return [];
  }, [tierOptions]);

  useEffect(() => {
    return () => {
      setState({
        bomType: '',
        allBoms: [],
      });
      setAllBOMOptions([]);
    };
  }, []);

  const handleAccordionToggle = (index) => {
    setActiveAccordion((prev) => (prev === index ? null : index));
  };

  useEffect(() => {
    if (productBOM && productBOM.length > 0) {
      setAllBOMOptions(productBOM);
    }
  }, [productBOM]);

  useEffect(() => {
    if (obj?.productType?.length > 0) {
      const callApi = async () => {
        if (obj?.productType?.length > 0) {
          await dispatch(
            getBOMOptions({
              isAllRecord: true,
              productTypeId: obj?.productType,
            }),
          );
        }
      };
      callApi();
    }
  }, [obj?.productType]);

  useEffect(() => {
    const callApi = async () => {
      if (devProductData?.supplierType?._id) {
        await dispatch(
          getBOMOptions({
            isAllRecord: true,
            productTypeId: devProductData?.supplierType?._id,
          }),
        );
      }

      const ssParams = {
        loggedInUserId: userInfo?.userId,
      };
      await dispatch(fetchUserDocumentsList());
      await dispatch(getSupplierStatusDetails(ssParams));
      await dispatch(
        getPCTypesDetails({
          loggedInUserId: userInfo?.userId,
          isActive: true,
          tier: 'Tier1',
        }),
      );
    };
    callApi();
  }, [dispatch, devProductData?.supplierType?._id, userInfo?.userId]);

  const handleBomTypeChange = (objData, value) => {
    setAllBOMOptions([]);
    const existingBomType = objData.bomType?.find((b) => b.id === value?._id);

    setState((prev) => ({
      ...prev,
      bomType: value?._id,
    }));

    if (existingBomType) {
      existingBomType.id = value?._id;
      existingBomType.isAllBom = existingBomType.hasOwnProperty('isAllBom') ? existingBomType.isAllBom : false;
      setState((prev) => ({
        ...prev,
        allBoms: existingBomType?.allBoms || [],
        isAllBom: existingBomType.isAllBom,
        placement: existingBomType?.placement || [],
      }));
    } else {
      objData.bomType = [
        ...(objData.bomType || []),
        {
          id: value?._id,
          allBoms: [],
          isAllBom: false,
          placement: [],
        },
      ];
    }
    return objData;
  };

  const handleIsAllBomChange = (objData, value) => {
    const isAllBom = value === 'allBom';
    setState((prev) => ({
      ...prev,
      isAllBom,
      allBoms: [],
    }));

    const selectedBomType = objData?.bomType?.find((b) => b?.id === state?.bomType);
    if (selectedBomType) {
      selectedBomType.isAllBom = isAllBom;
      selectedBomType.allBoms = [];
    }
    return objData;
  };

  const handleAllBomsChange = (objData, value) => {
    setState((prev) => ({
      ...prev,
      allBoms: value,
    }));

    const selectedBomType = objData?.bomType?.find((b) => b?.id === state?.bomType);
    if (selectedBomType) {
      selectedBomType.allBoms = value;
    }
    return objData;
  };

  const handlePlacementChange = (objData, value) => {
    setState((prev) => ({
      ...prev,
      placement: value,
    }));
    objData.placement = value;
    const selectedBomType = objData?.bomType?.find((b) => b?.id === state?.bomType);
    if (selectedBomType) {
      selectedBomType.placement = value;
    } else if (state.bomType) {
      objData.bomType = [
        ...(objData.bomType || []),
        {
          id: state.bomType,
          allBoms: [],
          isAllBom: false,
          placement: value,
        },
      ];
    }
    return objData;
  };

  useEffect(() => {
    if (devProductData?.supplierType?._id) {
      const objData = { ...obj };
      objData.productType = [devProductData?.supplierType?._id];
      updateSetting(objData);
    }
  }, [devProductData?.supplierType?._id]);

  const handleSelect = async (value, key, index) => {
    const objData = { ...obj };
    switch (key) {
      case 'bomType':
        handleBomTypeChange(objData, value);
        break;
      case 'isAllBom':
        handleIsAllBomChange(objData, value);
        break;
      case 'allBoms':
        handleAllBomsChange(objData, value);
        break;
      case 'placement':
        handlePlacementChange(objData, value);
        break;
      case 'mapOptionType':
        objData.mapOptionType = value;
        break;
      case 'ethicalStatus':
        objData.tier[index].ethicalStatus = value?.name;
        break;
      case 'verticalLine':
        objData[key] = value?.value;
        break;
      case 'productType':
        objData[key] = value;
        break;
      default:
        if (Array.isArray(value)) {
          objData[key] = value;
        } else {
          objData[key] = value?._id;
        }
    }

    updateSetting(objData);
  };

  const allBOMOptionsList = useMemo(() => {
    if (checkArray(allBOMOptions)) return createOptions(allBOMOptions, 'referenceCode', '_id');
    return [];
  }, [allBOMOptions]);

  const placementOptionsList = useMemo(() => {
    if (checkArray(placement_master)) return createOptions(placement_master, 'name', '_id');
    return [];
  }, [placement_master]);

  const statusIds =
    documentsList?.length > 0 ? documentsList?.find((doc) => doc?.name === 'Ethical Audit Status' || doc?.name === 'Ethical Audit')?.status : [];

  const ethicalOptions = supplierStatusList?.length > 0 ? supplierStatusList?.filter((supplierStatus) => statusIds?.includes(supplierStatus?._id)) : [];

  const handleImageError = (event) => {
    event.target.src = noImage;
  };

  useEffect(() => {
    const callALLBOM = async () => {
      await dispatch(getPlacementDetails({ isActive: true, bomTypeId: state?.bomType }));
    };
    if (state?.bomType) {
      callALLBOM();
    }
  }, [state?.bomType]);

  useEffect(() => {
    const callALLBOM = async () => {
      const params = {
        bomType: [state?.bomType],
        placementId: state?.isAllBom ? [] : obj?.bomType?.find((b) => b?.id === state?.bomType)?.placement,
      };
      await dispatch(fetchDPPBom(devProductData?._id, params));
    };
    if (state?.bomType && devProductData?._id && fromProduct) {
      callALLBOM();
    }
  }, [state?.bomType, obj?.bomType, state?.isAllBom]);

  const getSelectedTiers = (selectedTiers) => {
    const selectedTier = selectedTiers.map((key) => key.label).join(', ');
    return `${selectedTier}  Icons`;
  };

  const productTypeOptions = useMemo(
    () =>
      libraryBasicData?.productTypeId?.map((type) => ({
        value: type?._id,
        label: type?.name,
        ...type,
      })) || [],
    [libraryBasicData?.productTypeId],
  );

  useEffect(() => {
    if (allBOMOptionsList?.length === 1) {
      if (state?.isAllBom || (!state?.isAllBom && state?.placement?.length > 0)) {
        handleSelect([allBOMOptionsList[0]._id], 'allBoms');
      }
    }
  }, [allBOMOptionsList, state?.bomType, state?.isAllBom, state?.placement]);

  return (
    <>
      <div className="common-react-select">
        <p className="field-name">
          {t('DPP.CONTROL.PRODUCTJOURNEY.PRODUCTTYPE')}
          <span className="asterisk">*</span>
        </p>
        {fromProduct ? (
          <Select
            placeholder={t('DPP.CONTROL.PRODUCTJOURNEY.SELECT_PRODUCTTYPE')}
            options={pcTypeList}
            styles={customStylesNew}
            className="common-select"
            classNamePrefix="common-select"
            isDisabled
            getOptionLabel={(option) => option?.name}
            getOptionValue={(option) => option?._id}
            value={pcTypeList?.find((ele) => ele?._id === devProductData?.supplierType?._id) || null}
            onChange={(selected) => handleSelect(selected, 'productType')}
          />
        ) : (
          <MultiSelect
            placeholder={t('DPP.CONTROL.PRODUCTJOURNEY.SELECT_PRODUCTTYPE')}
            options={productTypeOptions}
            className="product-custom-multiselect common-new-multiselect w-100"
            labelledBy={t('DPP.CONTROL.PRODUCTJOURNEY.PRODUCTTYPE')}
            onChange={(selected) =>
              handleSelect(
                selected.map((val) => val.value),
                'productType',
              )
            }
            isDisabled={fromProduct}
            value={productTypeOptions?.filter((val) => checkArray(productTypeOptions) && obj?.productType?.includes(val.value))}
          />
        )}
      </div>
      <div className="common-react-select">
        <p className="field-name">
          {t('DPP.CONTROL.PRODUCTJOURNEY.BOMTYPE')}
          <span className="asterisk">*</span>
        </p>

        <Select
          placeholder={t('DPP.CONTROL.PRODUCTJOURNEY.SELECT_BOMTYPE')}
          options={bomOptionsList}
          styles={customStylesNew}
          className="common-select"
          classNamePrefix="common-select"
          isDisabled={!fromProduct ? !obj?.productType?.length : false}
          getOptionLabel={(option) => option?.name}
          getOptionValue={(option) => option?._id}
          value={bomOptionsList?.find((ele) => ele?._id === state?.bomType) || null}
          onChange={(selected) => handleSelect(selected, 'bomType')} // Handle bomType change
        />
      </div>

      <FormGroup className="mb-16">
        <div className="d-flex align-items-center">
          <p className="custom-radio mb-0">
            <input type="radio" id="allBom" value="allBom" onChange={(e) => handleSelect(e.target.value, 'isAllBom')} name="bom" checked={state?.isAllBom} />
            <label className="text-black text-bold" htmlFor="allBom">
              {t('DPP.CONTROL.PRODUCTJOURNEY.ALLBOMS')}
            </label>
          </p>
          <p className="custom-radio mb-0 ml-4">
            <input
              type="radio"
              id="specificBom"
              value="specificBom"
              onChange={(e) => handleSelect(e.target.value, 'isAllBom')}
              name="bom"
              checked={!state?.isAllBom}
            />
            <label className="text-black text-bold" htmlFor="specificBom">
              {' '}
              {t('DPP.CONTROL.PRODUCTJOURNEY.SPECIFICPLACEMENTS')}
            </label>
          </p>
        </div>
      </FormGroup>

      {fromProduct && state?.bomType && state?.isAllBom && (
        <div className="common-react-select">
          <p className="field-name">{t('DPP.CONTROL.PRODUCTJOURNEY.ALLBOMS')}</p>
          <MultiSelect
            name="group"
            options={allBOMOptionsList}
            className="product-custom-multiselect common-new-multiselect w-100"
            labelledBy={t('DPP.CONTROL.PRODUCTJOURNEY.SELECT_BOM')}
            onChange={(selected) =>
              handleSelect(
                selected.map((val) => val._id),
                'allBoms',
              )
            }
            value={allBOMOptionsList?.filter((val) => checkArray(allBOMOptionsList) && state?.allBoms?.includes(val._id))}
          />
        </div>
      )}

      {!state?.isAllBom && state?.bomType && (
        <div className="common-react-select">
          <p className="field-name">{t('DPP.CONTROL.PRODUCTJOURNEY.PLACEMENT')}</p>

          <MultiSelect
            name="group"
            options={placementOptionsList}
            className="product-custom-multiselect common-new-multiselect w-100"
            labelledBy={t('DPP.CONTROL.PRODUCTJOURNEY.SELECT_PLACEMENT')}
            onChange={(selected) =>
              handleSelect(
                selected.map((val) => val._id),
                'placement',
              )
            }
            // value={placementOptionsList?.filter((val) => checkArray(placementOptionsList) && obj?.placement?.includes(val._id))}
            value={placementOptionsList?.filter(
              (val) => checkArray(placementOptionsList) && obj?.bomType?.find((b) => b?.id === state?.bomType)?.placement?.includes(val._id),
            )}
          />
        </div>
      )}

      {!fromProduct && state?.isAllBom && state?.bomType && (
        <div className="common-react-select">
          <p className="field-name">{t('DPP.CONTROL.PRODUCTJOURNEY.ALLBOMS')}</p>
          <MultiSelect
            name="group"
            options={[]}
            className="product-custom-multiselect common-new-multiselect w-100"
            labelledBy={t('DPP.CONTROL.PRODUCTJOURNEY.SELECT_ALL_BOM')}
            overrideStrings={{
              selectSomeItems: t('DPP.CONTROL.PRODUCTJOURNEY.SELECT_ALL_BOM'),
            }}
            onChange={(selected) =>
              handleSelect(
                selected.map((val) => val._id),
                'allBoms',
              )
            }
            value={[]}
          />
        </div>
      )}
      {fromProduct && !state?.isAllBom && state?.bomType && (
        <div className="common-react-select">
          <p className="field-name">{t('DPP.CONTROL.PRODUCTJOURNEY.ALLBOMS')}</p>
          <MultiSelect
            name="group"
            options={allBOMOptionsList}
            className="product-custom-multiselect common-new-multiselect w-100"
            labelledBy={t('DPP.CONTROL.PRODUCTJOURNEY.SELECT_ALL_BOM')}
            overrideStrings={{
              selectSomeItems: t('DPP.CONTROL.PRODUCTJOURNEY.SELECT_ALL_BOM'),
            }}
            onChange={(selected) =>
              handleSelect(
                selected.map((val) => val._id),
                'allBoms',
              )
            }
            value={allBOMOptionsList?.filter((val) => checkArray(allBOMOptionsList) && state?.allBoms?.includes(val._id))}
          />
        </div>
      )}

      <div className="common-input-control mb-0">
        <p className="field-name">{t('DPP.CONTROL.PRODUCTJOURNEY.SUB_HEADER_TITLE')}</p>
        <input
          type="text"
          className="form-control"
          value={obj?.subHeaderTitle}
          placeholder={t('DPP.CONTROL.PRODUCTJOURNEY.ENTER_SUBHEADER_TITLE')}
          onChange={(e) => onChange(e.target.value, 'subHeaderTitle')}
          maxLength="40"
        />
      </div>

      <div className="d-flex">
        <AlignmentConfig obj={obj} handleAlignment={handleOtherConfig} dataName="subHeaderAlign" />
        <ColorConfig obj={obj} handleColor={handleOtherConfig} dataName="subHeaderColor" />
        <BoldConfig obj={obj} handleBold={handleOtherConfig} dataName="subHeaderBold" />
      </div>

      <p className="f-16 mb-0 text-medium">{t('DPP.CONTROL.PRODUCTJOURNEY.PRODUCT_JOURNEY_DESCRIPTION')}</p>
      <div className="d-flex">
        <AlignmentConfig obj={obj} handleAlignment={handleOtherConfig} dataName="journeyDescAlign" />
        <ColorConfig obj={obj} handleColor={handleOtherConfig} dataName="journeyDescColor" />
        <BoldConfig obj={obj} handleBold={handleOtherConfig} dataName="journeyDescBold" />
      </div>
      <FormGroup>
        <div className="form-group url-container">
          <textarea
            type="text"
            onChange={(e) => onChange(e.target.value, 'productJourneyDescription')}
            value={obj?.productJourneyDescription}
            className="form-control text-bordered"
            placeholder={t('DPP.CONTROL.PRODUCTJOURNEY.ENTER_TEXT_HERE')}
            rows="7"
          />
        </div>
      </FormGroup>
      <div className="common-react-select">
        <p className="field-name">{t('DPP.CONTROL.PRODUCTJOURNEY.TIER_SELECTION')}</p>

        <MultiSelect
          name="group"
          options={TierOptionsList}
          className="product-custom-multiselect common-new-multiselect w-100"
          labelledBy={t('DPP.CONTROL.PRODUCTJOURNEY.SELECT_TIER')}
          onChange={(selected) =>
            handleSelect(
              selected.map((val) => val),
              'tier',
            )
          }
          value={obj?.tier || []}
        />
      </div>
      <FormGroup className="mb-0">
        {obj?.tier?.length > 0 && <p className="f-16 mb-2 text-medium">{getSelectedTiers(obj.tier)}</p>}
        <div className="d-flex">
          {obj?.tier?.map((data, index) => {
            const getTierSvg = (tierValue) => {
              return `https://${process.env.REACT_APP_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${
                process.env.REACT_APP_COMMON_RESOURCE
              }/Tier_${tierValue?.replace('Tier', '') || '1'}.svg`;
            };

            return (
              <div className="heading-icon-container mb-3" key={data?.value}>
                <figure>
                  <img src={data?.tierIcon ? setImage(data?.tierIcon) : getTierSvg(data?.value)} alt={data?.name || 'Tier Icon'} onError={handleImageError} />
                </figure>
                <button
                  type="button"
                  aria-label="Upload"
                  onClick={() => handleImageUpload('product_journey_tier', '', index)}
                  className="btn p-0 d-inline-flex"
                >
                  <i className="icon icon-Upload-1" />
                </button>
              </div>
            );
          })}
        </div>
      </FormGroup>
      <FormGroup className="mb-0">
        {obj?.tier?.length > 0 && (
          <>
            <p className="f-16 mb-2 text-medium">{t('DPP.CONTROL.PRODUCTJOURNEY.TRANSPORT_ICON')}</p>
            <div className="d-flex">
              <div className="heading-icon-container mb-3">
                <figure>
                  <img
                    src={
                      obj?.transportIcon
                        ? setImage(obj?.transportIcon)
                        : `https://${process.env.REACT_APP_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${process.env.REACT_APP_COMMON_RESOURCE}/Transport_Icon.svg`
                    }
                    alt="Transport Icon"
                    onError={handleImageError}
                  />
                </figure>
                <button type="button" aria-label="Upload" onClick={() => handleImageUpload('product_journey_transport', '')} className="btn p-0 d-inline-flex">
                  <i className="icon icon-Upload-1" />
                </button>
              </div>
            </div>
          </>
        )}
      </FormGroup>
      <div className="d-flex mb-24">
        <div className="mr-4">
          <p className="f-16 text-bold mb-2">{t('DPP.CONTROL.PRODUCTJOURNEY.VERTICAL_LINE')}</p>
          <Select
            options={verticalStyleOptions}
            styles={customStylesNew}
            className="common-select"
            menuPosition="fixed"
            classNamePrefix="common-select"
            getOptionLabel={({ label }) => `${label}`}
            getOptionValue={({ value }) => `${value}`}
            value={verticalStyleOptions?.find((ele) => ele?.value === obj?.verticalLine) || null}
            onChange={(selected) => handleSelect(selected, 'verticalLine')}
          />
        </div>
        <ColorConfig obj={obj} paddingTopZero handleColor={handleOtherConfig} dataName="verticalLineColor" />
        <div className="thickness-container">
          <img src={borderThickSvg} alt="thickness" />
          <div className="ml-16 w-80px">
            <Select
              options={borderStyleOptions}
              className="common-select"
              classNamePrefix="common-select"
              styles={customStylesBorderThickness}
              getOptionLabel={({ label }) => `${label}`}
              getOptionValue={({ value }) => `${value}`}
              value={borderStyleOptions?.find((ele) => ele?.value === obj?.otherConfiguration?.borderThickness) || null}
              onChange={(selected) => handleOtherConfig(selected, 'borderThickness')}
            />
          </div>
        </div>
      </div>
      <FormGroup className="mb-2">
        <div className="d-flex align-items-center">
          <p className="custom-radio mb-0">
            <input
              type="radio"
              id="staticOption"
              value="static"
              onChange={(e) => handleSelect(e.target.value, 'mapOptionType')}
              name="option"
              checked={obj?.mapOptionType === 'static' || !obj?.mapOptionType}
            />
            <label className="text-black" htmlFor="staticOption">
              {t('DPP.CONTROL.PRODUCTJOURNEY.STATIC')}
            </label>
          </p>
          <p className="custom-radio mb-0 ml-4">
            <input
              type="radio"
              id="googleOption"
              value="google"
              onChange={(e) => handleSelect(e.target.value, 'mapOptionType')}
              name="option"
              checked={obj?.mapOptionType === 'google'}
            />
            <label className="text-black" htmlFor="googleOption">
              {t('DPP.CONTROL.PRODUCTJOURNEY.GOOGLE')}
            </label>
          </p>
        </div>
      </FormGroup>
      {obj?.tier?.map((data, index) => (
        <div className="collapse-card mt-3" key={index}>
          <Accordion activeKey={activeAccordion === index ? `${index}` : null}>
            <Card className="mb-3">
              <Card.Header className="d-flex align-items-center justify-content-between p-8">
                <input
                  type="text"
                  className="form-control tier-input"
                  value={data?.name}
                  onChange={(e) => onChange(e.target.value, 'name', index)}
                  placeholder="Enter Tier Name"
                />
                <Accordion.Toggle
                  as={Button}
                  variant="link"
                  eventKey={`${index}`}
                  onClick={() => handleAccordionToggle(index)}
                  className="text-decoration-none btn-toggle"
                >
                  <i className={`icon-new-down-arrow-icon drop-icon ml-16 f-18 ${activeAccordion === index ? 'rotated' : ''}`} />
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey={`${index}`}>
                <Card.Body>
                  <p className="f-16 text-bold mb-0">{t('DPP.CONTROL.PRODUCTJOURNEY.DESCRIPTION')}</p>
                  <div className="d-flex">
                    <AlignmentConfig obj={obj} handleAlignment={handleOtherConfig} dataName={`${data?.value}DescriptionAlign`} />
                    <ColorConfig obj={obj} handleColor={handleOtherConfig} dataName={`${data?.value}DescriptionColor`} />
                    <BoldConfig obj={obj} handleBold={handleOtherConfig} dataName={`${data?.value}DescriptionBold`} />
                  </div>
                  <FormGroup>
                    <div className="form-group url-container">
                      <textarea
                        type="text"
                        onChange={(e) => onChange(e.target.value, 'tierDescription', index)}
                        value={data?.tierDescription}
                        className="form-control text-bordered"
                        placeholder={t('DPP.CONTROL.PRODUCTJOURNEY.ENTER_TEXT_HERE')}
                        rows="7"
                      />
                    </div>
                  </FormGroup>

                  <div className="common-react-select">
                    <p className="field-name">{t('DPP.CONTROL.PRODUCTJOURNEY.ETHICAL_AUDIT_STATUS')}</p>

                    <Select
                      placeholder={t('DPP.CONTROL.PRODUCTJOURNEY.SELECT_STATUS')}
                      options={ethicalOptions}
                      styles={customStylesNew}
                      className="common-select"
                      classNamePrefix="common-select"
                      getOptionLabel={(option) => option?.name}
                      getOptionValue={(option) => option?.name}
                      value={ethicalOptions?.find((ele) => ele?.name === data?.ethicalStatus)}
                      onChange={(selected) => handleSelect(selected, 'ethicalStatus', index)}
                      isClearable
                    />
                  </div>

                  <div className="common-input-control">
                    <p className="f-16 text-bold field-name">{t('DPP.CONTROL.PRODUCTJOURNEY.ETHICAL_AUDIT_DPP_STATUS')}</p>
                    <input
                      type="text"
                      className="form-control"
                      value={data?.ethicalAuditDPPStatus}
                      placeholder={t('DPP.CONTROL.PRODUCTJOURNEY.ENTER_STATUS')}
                      onChange={(e) => onChange(e.target.value, 'ethicalAuditDPPStatus', index)}
                      maxLength="40"
                    />
                  </div>

                  <p className="f-16 text-bold mb-2">{t('DPP.CONTROL.PRODUCTJOURNEY.ETHICAL_AUDIT_ICON')}</p>
                  <div className="heading-icon-container mb-3">
                    <figure>
                      <img src={data?.ethicalAuditIcon ? setImage(data?.ethicalAuditIcon) : noImage} alt="" onError={handleImageError} />
                    </figure>
                    <button
                      type="button"
                      aria-label="Upload"
                      onClick={() => handleImageUpload('product_journey_ethicalIcon', '', index)}
                      className="btn p-0 d-inline-flex"
                    >
                      <i className="icon icon-Upload-1" />
                    </button>
                  </div>
                  <FormGroup>
                    <p className="f-16 text-bold mb-2">{t('DPP.CONTROL.PRODUCTJOURNEY.ETHICAL_AUDIT_DPP_DESCRIPTION')}</p>
                    <div className="form-group url-container mt-2">
                      <textarea
                        type="text"
                        onChange={(e) => onChange(e.target.value, 'ethicalAuditDPPDescription', index)}
                        value={data?.ethicalAuditDPPDescription}
                        className="form-control text-bordered"
                        placeholder={t('DPP.CONTROL.PRODUCTJOURNEY.ENTER_TEXT_HERE')}
                        rows="7"
                      />
                    </div>
                  </FormGroup>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </div>
      ))}
    </>
  );
}

export default ProductJourneySetting;
